<template lang="pug">
	
	a.album-cover(:href='href' target='blank' @mouseenter="onHover" @mouseleave="onHover")
		img(:src="img").cover
		img(:src="shadow").cover-shadow
		img(:src="tongue").cover-tongue
		.album-legend 
			span.word {{translate('globals.listen')}}
			p.album-name
				span(v-for="l in name") {{l}}
			img(src="assets/images/play-icon.png").icon

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scrollable from '~abstracts/scrollable'
	import Globals from '~utils/Globals'

  @Component({
		name: 'AlbumCover',
		components: {},
		props:['name','title','href'],
		data: function() {
			return {
				img: `assets/images/album-${this.name}-cover.png`,
				shadow: `assets/images/album-shadow.png`,
				tongue: `assets/images/album-${this.name}-tongue.png`
			}
		}
	})

	class AlbumCover extends Scrollable {

		mounted () {
			super.mounted()

			
		}

		init () {
			super.init()
			this._dom()
		}

		_bind () {
			super._bind()
		}

		_dom () {
			this.$name = this.$el.querySelector('.album-name')
			this.$nameLetter = this.$el.querySelectorAll('.album-name span')
			this.$icon = this.$el.querySelector('.icon')

			this.nameWidth = this.$name.getBoundingClientRect().width + 4
			TweenMax.set(this.$icon,{x:-this.nameWidth})
			
			this.tl = new TimelineMax({paused: true})
			this.tl.to(this.$icon,.3,{x:0},0)
			this.tl.staggerTo(this.$nameLetter,.3,{y:0,opacity:1},.05,0)

		}

		onHover (e) {

			if(e.type === "mouseenter") {
				this.tl.play()
			} else if(e.type === "mouseleave") {
				this.tl.reverse(0)
			}
		}

		_intervals () {}

        _points () {}

		_resize () {
			super._resize()

			
			this.$el.style.height = Globals.responsiveHeight(330) + "px"
			this.$el.style.width = Globals.responsiveHeight(330) * 340 / 330 + "px"

			this._intervals()
      this._points()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}

	}

	export default AlbumCover

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.album-cover
		width 330px
		height 330px
		position relative
		margin-left 190px
		cursor pointer

		&:hover
			img.cover-tongue
				transform translatex(55%)

		img.cover
			position absolute
			top 0
			right 0
			z-index 50
			height 100%
			

		img.cover-tongue
			position absolute
			top 0px
			right 0
			transition all .3s
			z-index 30
			height 100%
			transform translatex(40%)

		img.cover-shadow
			position absolute
			top 0px
			left 0px
			transition all .3s
			z-index 30
			height 100%
			transform translatex(-100%)

		.album-legend
			position absolute
			left 0
			bottom em(-32px)
			display flex
			align-items center

			.word
				color #fff
				font-family $FONT_SECONDARY
				font-weight 300
				letter-spacing .15em
				text-transform uppercase
				font-size em(15px)

			.album-name
				position relative
				margin-left 4px
				margin-bottom 1px

				span
					display inline-block
					color #fff
					font-family $FONT_SECONDARY
					font-weight 300
					letter-spacing .15em
					text-transform uppercase
					font-size em(15px)
					font-weight 700
					opacity 0
					transform translateY(5px)
			
			img
				margin-left 10px
				width 24px

</style>


// WEBPACK FOOTER //
// album-cover.vue?3aeece9f